import { Component, inject } from '@angular/core';
import { ChangeRrcLimitDialogData, ChangeRrcLimitFormField } from "./types/change-rrc-limit.types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { changeRrcLimitModalName, rrcLimitsResourceType } from "./configs/change-rrc-limit-modal-config";
import { MatButton } from "@angular/material/button";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { changeRrcLimitFormFields } from "./configs/change-rrc-limit-form-fields";
import { ChangeRrcLimitModalService } from "./services/change-rrc-limit-modal.service";
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  CustomMatSelectComponent
} from "../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import { LoaderComponent } from "../../../../../../shared/components/loader/loader.component";
import { EditModeService } from "../../../../../../core/services/edit-mode.service";
import { RecordData, RecordUpdateRequestParams, SelectData } from "../../../../../../core/types/records-table.types";

@Component({
  selector: 'app-change-rrc-limit-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    CustomMatSelectComponent,
    ReactiveFormsModule,
    LoaderComponent
  ],
  templateUrl: './change-rrc-limit-modal.component.html',
  styleUrl: './change-rrc-limit-modal.component.scss',
  providers: [ EditModeService ]
})
export class ChangeRrcLimitModalComponent extends BaseModalComponent {
  private changeRrcLimitDialogData = inject<ChangeRrcLimitDialogData>(MAT_DIALOG_DATA);
  private changeRrcLimitModalService: ChangeRrcLimitModalService = inject(ChangeRrcLimitModalService);

  public readonly changeRrcLimitFormFields = changeRrcLimitFormFields;
  public changeRrcLimitFormGroup: FormGroup = new FormGroup({});
  public changeRrcLimitSelectData: Array<SelectData> = [];

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.initComponent();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(changeRrcLimitModalName);
  }

  public getSelectedValue(key: string): string {
    return this.changeRrcLimitFormGroup.get(key)?.value;
  }

  public async selectedChange(value: string, key: string): Promise<void> {
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: rrcLimitsResourceType.path,
      recordId: Number(this.changeRrcLimitDialogData.changeLimitDto.id),
      fieldName: key,
      value: value || null
    };

    this.loadingService.setIsLoadingState(true);
    this.updatedRecordField<RecordData>(recordUpdateRequestParams)
      .then(result => {
        const changeLimitDto = result['changeLimitDto'] as RecordData;
        this.changeRrcLimitDialogData.changeLimitDto = changeLimitDto;
        this.changeRrcLimitFormGroup.patchValue(changeLimitDto);
      })
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private async initComponent(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    this.modalStatesService.openModal(changeRrcLimitModalName);
    this.changeRrcLimitSelectData = await this.changeRrcLimitModalService.fetchSelectData(Number(this.changeRrcLimitDialogData.changeLimitDto.id))
      .catch(() => [])
      .finally(() => this.loadingService.setIsLoadingState(false));
    this.changeRrcLimitFormGroup = this.baseModalService.getFormGroup<ChangeRrcLimitFormField>(changeRrcLimitFormFields);
    this.changeRrcLimitFormGroup.patchValue(this.changeRrcLimitDialogData.changeLimitDto);
  }
}
